import Layout from "@/components/layout";
import webengage from "@/webengage";
import Image from "next/image";
import Link from "next/link";

const contactInfos = [
  {
    id: 1,
    iconUrl: "/call-icon.svg",
    iconAlt: "call-icon",
    info: "+91 7973938627",
    url: "tel:+917973938627",
  },
  {
    id: 2,
    iconUrl: "/email-icon.svg",
    iconAlt: "email-icon",
    info: "ceo@thefuture.university",
    url: "mailto:ceo@thefuture.university",
  },
  {
    id: 3,
    iconUrl: "/location-icon.svg",
    iconAlt: "location-icon",
    info: "Mohali, Chandigarh, Punjab",
  },
];

const socialIcons = [
  {
    socialUrl: "https://in.linkedin.com/company/thefutureuniversity",
    iconUrl: "/linkedin.svg",
    alt: "linkedin-icon",
  },
  {
    socialUrl: "https://wa.me/+919056187997",
    iconUrl: "/whatsapp-icon.svg",
    alt: "whatsapp-icon",
  },
  {
    socialUrl: "https://youtube.com/@tradewiseofficial",
    iconUrl: "/youtube-icon.svg",
    alt: "youtube-icon",
  },
  {
    socialUrl: "https://www.instagram.com/tradewise__/",
    iconUrl: "/instagram-icon.svg",
    alt: "instagram-icon",
  },
];

const contact = () => {
  return (
    <Layout>
      <div className="px-6 pt-6 pb-3 m-4 mb-2 rounded-2xl shadow-[0px_2.02px_8.081px_0px_rgba(99,99,99,0.20)] relative max-w-lg mx-auto">
        <h1 className="text-center text-2xl">Get In Touch With Us</h1>

        <div className="mt-6 mb-4">
          {contactInfos.map((item) => (
            <a
              href={item?.url}
              className="flex gap-[10px] items-center"
              key={item.id}
            >
              <Image
                src={item.iconUrl}
                width={20}
                height={20}
                alt={item.iconAlt}
              />

              <p className="font-medium text-[#000000CC]">{item.info}</p>
            </a>
          ))}
        </div>

        <div className="flex gap-3 justify-end">
          {socialIcons.map((item, i) => (
            <Link
              href={item.socialUrl}
              onClick={() => {
                const _webengage = webengage();
                if (_webengage && item.alt === "whatsapp-icon") {
                  _webengage.track("Contact Us", {
                    source: "Tradewise",
                    type: "Chat",
                  });
                }
              }}
              key={i}
              target="_blank"
            >
              <Image
                src={item.iconUrl}
                width={24}
                height={24}
                alt={item.alt}
                className=""
              />
            </Link>
          ))}
        </div>

        <Image
          src="/contact-us-vector.svg"
          width={227}
          height={181}
          alt="designing-vector"
          className="absolute right-0 bottom-0 -z-10"
        />
      </div>

      <p className="text-sm text-[#666363] text-center mt-1 md:mt-2">
        Working Hours (10 AM - 10 PM)
      </p>
    </Layout>
  );
};

export default contact;
